import { useTranslation } from 'react-i18next';

const en = {
  edit: 'Edit campaign', title: 'Edit campaign content',
  description: 'Update the campaign presentation. Financial settings, permissions and competition dates stay in campaign administration.',
  loading: 'Loading campaign content…', loadError: 'Unable to load campaign content. Your access may have changed.',
  saveError: 'Unable to save campaign content. Try again.', invalid: 'Check the campaign name and artwork URLs.',
  periodLocked: 'The competition has received clips or reports. Rules, descriptions and posting requirements are locked; the name and artwork can still be updated.',
  finalized: 'This campaign has been finalized and can no longer be edited.',
  save: 'Save changes', saving: 'Saving…', cancel: 'Cancel', retry: 'Try again',
  information: 'Information', rules: 'Rules and requirements', artwork: 'Artwork', preview: 'Preview',
  markdown: 'Markdown supports headings, lists, tables, bold text and links. HTML and embedded media are not displayed.',
  opens: 'Public launch',
  name: 'Name', descriptionField: 'Description (Markdown)',
  rules_allowed: 'Allowed content (Markdown)', rules_forbidden: 'Forbidden content (Markdown)',
  rules_attention: 'Important requirements (Markdown)', rules_warning: 'Warnings (Markdown)',
  required_hashtags: 'Required hashtags', required_mention: 'Required mentions',
  banner_url: 'Banner URL', logo_url: 'Logo URL', emptyPreview: 'Write campaign content to preview it here.',
} as const;
type CampaignContentCopy = { [Key in keyof typeof en]: string };
const pt: CampaignContentCopy = {
  edit: 'Editar campanha', title: 'Editar conteúdo da campanha',
  description: 'Atualize a apresentação da campanha. Valores, permissões e datas da competição permanecem na administração da campanha.',
  loading: 'Carregando conteúdo da campanha…', loadError: 'Não foi possível carregar o conteúdo. Seu acesso pode ter mudado.',
  saveError: 'Não foi possível salvar o conteúdo. Tente novamente.', invalid: 'Confira o nome da campanha e os endereços das imagens.',
  periodLocked: 'A competição já recebeu clipes ou relatórios. Regras, descrições e requisitos de publicação estão bloqueados; o nome e as imagens ainda podem ser atualizados.',
  finalized: 'Esta campanha foi finalizada e não pode mais ser editada.',
  save: 'Salvar alterações', saving: 'Salvando…', cancel: 'Cancelar', retry: 'Tentar novamente',
  information: 'Informações', rules: 'Regras e requisitos', artwork: 'Imagens', preview: 'Prévia',
  markdown: 'Markdown permite títulos, listas, tabelas, negrito e links. HTML e mídias incorporadas não são exibidos.',
  opens: 'Abertura ao público',
  name: 'Nome', descriptionField: 'Descrição (Markdown)',
  rules_allowed: 'Conteúdo permitido (Markdown)', rules_forbidden: 'Conteúdo proibido (Markdown)',
  rules_attention: 'Requisitos importantes (Markdown)', rules_warning: 'Avisos (Markdown)',
  required_hashtags: 'Hashtags obrigatórias', required_mention: 'Marcações obrigatórias',
  banner_url: 'URL do banner', logo_url: 'URL do logo', emptyPreview: 'Escreva o conteúdo da campanha para visualizar a prévia.',
};

export function useCampaignAuditContentCopy(): CampaignContentCopy {
  const { i18n } = useTranslation();
  return (i18n?.resolvedLanguage || i18n?.language || '').startsWith('pt') ? pt : en;
}
